import { useState } from "react";
import { generateUUID } from "common/utils/uuid";

const DEFAULT_DURATION_MS = 5000;
const MAX_VISIBLE_TOASTS = 5;

// eslint-disable-next-line import/prefer-default-export
export function usePinningToast() {
  const [toasts, setToasts] = useState([]);

  function addToast({ title, description, variant = "default", duration = DEFAULT_DURATION_MS }) {
    const id = generateUUID();

    setToasts(prev => [
      ...prev.slice(-(MAX_VISIBLE_TOASTS - 1)),
      { id, title, description, variant, removing: false }
    ]);

    if (duration > 0) {
      setTimeout(() => dismissToast(id), duration);
    }

    return id;
  }

  function dismissToast(id) {
    setToasts(prev => prev.map(t => (t.id === id ? { ...t, removing: true } : t)));

    // Remove from DOM after exit animation
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 300);
  }

  function clearAll() {
    setToasts([]);
  }

  return {
    toasts,
    dismiss: dismissToast,
    clearAll,
    toast: props => addToast(props),
    success: props => addToast({ ...props, variant: "success" }),
    error: props => addToast({ ...props, variant: "error" }),
    warning: props => addToast({ ...props, variant: "warning" }),
    info: props => addToast({ ...props, variant: "info" })
  };
}
